/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsCollectionPreviewData } from './hosports-collection-preview.data';
import { IHosportsCollectionPreviewProps } from './hosports-collection-preview.props.autogenerated';

export interface IHosportsCollectionPreviewViewProps extends IHosportsCollectionPreviewProps<IHosportsCollectionPreviewData> {

}

/**
 *
 * HosportsCollectionPreview component
 * @extends {React.PureComponent<IHosportsCollectionPreviewProps<IHosportsCollectionPreviewData>>}
 */
class HosportsCollectionPreview extends React.PureComponent<IHosportsCollectionPreviewProps<IHosportsCollectionPreviewData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsCollectionPreview;
